//@flow
import React, { Component } from 'react';
import { type TableHeaderOptionProps } from '../';
import TableHeaderDesktop from './TableHeaderDeskop';
import TableHeaderDeviceRow1 from './TableHeaderDeviceRow1';
import TableHeaderDeviceRow2 from './TableHeaderDeviceRow2';

type Props = {
  tableHeaderOptions: TableHeaderOptionProps,
  desktop?: boolean,
  deviceRow1?: boolean,
  deviceRow2?: boolean
};

export default class TableHeader extends Component<Props> {
  render() {
    return (
      <>
        {this.props.desktop && (
          <TableHeaderDesktop options={this.props.tableHeaderOptions.desktop} />
        )}
        {this.props.deviceRow1 && (
          <TableHeaderDeviceRow1
            options={this.props.tableHeaderOptions.device.row1}
          />
        )}
        {this.props.deviceRow2 && (
          <TableHeaderDeviceRow2
            options={this.props.tableHeaderOptions.device.row2}
          />
        )}
      </>
    );
  }
}
